import { useDispatch, useSelector } from 'react-redux';
import useLocalStore from '../../../hooks/useLocalStore';
import FJActionImageManipulation from '../../../redux/action/FJActionImageManipulation';
import { setSliceIsDraggingFileAction } from '../../../redux/slices/FJSliceCommon';
import FJImageManipulationInput from './FJImageManipulationInput';
import { useMemo } from 'react';
import FJConstant from '../../../constants/FJConstant';
import FJActionEditPage from '../../../redux/action/FJActionEditPage.js';

const FJImageManipulationInputContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();

    const uploadImageInfo = useSelector(state => state.imageManipulation.uploadImageInfo);
    const isDraggingFile = useSelector(state => state.common.isDraggingFile);
    const taskStatus = useSelector(state => state.common.taskStatus);

    const disableUpload = useMemo(() => {
        return taskStatus !== FJConstant.DEFAULT && taskStatus !== FJConstant.ERROR;
    }, [taskStatus]);

    const uploadImg = file => {
        dispatch(FJActionImageManipulation.uploadImageAction(file));
    };

    const openMediaLibrary = () => {
        dispatch(FJActionEditPage.openMediaLibraryAction());
    };
    const _setIsDraggingFile = value => {
        dispatch(setSliceIsDraggingFileAction(value));
    };
    return (
        <FJImageManipulationInput
            openMediaLibrary={openMediaLibrary}
            uploadImageInfo={uploadImageInfo}
            isDraggingFile={isDraggingFile}
            disableUpload={disableUpload}
            uploadImg={uploadImg}
            setIsDraggingFile={_setIsDraggingFile}
        />
    );
};
export default FJImageManipulationInputContainer;
